import onError from '@common/globalEvents/utils/onError'
import onUnhandledRejection from '@common/globalEvents/utils/onUnhandledRejection'

import handleError from './utils/handleError'

/** GlobalErrorkezelők inicializálása. */
export default function initGlobalErrorHandlers (): void {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/error_event
  onError(handleError)

  // https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
  onUnhandledRejection(handleError)
}
